<div class="income-expense-tabs-container">
    
    <!-- Custom Tab Header -->
    <div class="tab-header flex items-center gap-2 p-1.5 bg-gray-100 dark:bg-slate-800 rounded-2xl mb-6">
        <button 
            (click)="selectedTabIndex = 0"
            class="tab-button flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300"
            [ngClass]="{
                'active bg-white dark:bg-slate-700 shadow-sm text-emerald-600': selectedTabIndex === 0,
                'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': selectedTabIndex !== 0
            }">
            <div class="h-8 w-8 rounded-lg flex items-center justify-center"
                 [ngClass]="{
                    'bg-emerald-100 dark:bg-emerald-900/30': selectedTabIndex === 0,
                    'bg-gray-200 dark:bg-slate-600': selectedTabIndex !== 0
                 }">
                <mat-icon [svgIcon]="'tabler_outline:trending-up'" 
                    class="h-5 w-5"
                    [ngClass]="selectedTabIndex === 0 ? 'text-emerald-600' : 'text-gray-400'"></mat-icon>
            </div>
            <span>Przychody</span>
        </button>
        <button 
            (click)="selectedTabIndex = 1"
            class="tab-button flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300"
            [ngClass]="{
                'active bg-white dark:bg-slate-700 shadow-sm text-rose-600': selectedTabIndex === 1,
                'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300': selectedTabIndex !== 1
            }">
            <div class="h-8 w-8 rounded-lg flex items-center justify-center"
                 [ngClass]="{
                    'bg-rose-100 dark:bg-rose-900/30': selectedTabIndex === 1,
                    'bg-gray-200 dark:bg-slate-600': selectedTabIndex !== 1
                 }">
                <mat-icon [svgIcon]="'tabler_outline:trending-down'" 
                    class="h-5 w-5"
                    [ngClass]="selectedTabIndex === 1 ? 'text-rose-600' : 'text-gray-400'"></mat-icon>
            </div>
            <span>Koszty</span>
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
        <div *ngIf="selectedTabIndex === 0" class="tab-panel animate-fadeIn">
            <invoice-card></invoice-card>
        </div>
        <div *ngIf="selectedTabIndex === 1" class="tab-panel animate-fadeIn">
            <expense-card></expense-card>
        </div>
    </div>

</div>
